export const isSearchFilterExperienceEnabled = initData =>
    initData &&
    initData.splitTests &&
    initData.splitTests['search_filter_experience'] === true &&
    initData.discoverEnabled;

export const isBrowseFilterExperienceEnabled = initData =>
    initData &&
    initData.featureSwitches &&
    initData.featureSwitches['browse-filter-experience'] &&
    initData.discoverEnabled;

export const isDiscoverOnCustomResultPageEnabled = initData =>
    initData &&
    initData.featureSwitches &&
    initData.featureSwitches['discover-on-custom-result-page'] &&
    initData.discoverEnabled;
